// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3lpAF","content":"styles_content__13jMn","checkbox":"styles_checkbox__3P3bi","checkboxLabel":"styles_checkboxLabel__2652w"};